import { useMemo } from "react";
import { TripX } from "@/types/trip";
import { useAllTripItineraryItems } from "@/hooks/useAllTripItineraryItems";
import { DateTime } from "luxon";

interface CalendarItem {
  id: string | number;
  name: string;
  start_time: string;
  timezone: string;
}

export const useCalendarLogic = (
  startBlock: Date,
  endBlock: Date,
  selectedTrip: TripX | null
) => {
  // Generate array of dates using Luxon
  const days = useMemo(() => {
    const start = DateTime.fromJSDate(startBlock);
    const end = DateTime.fromJSDate(endBlock);

    const numberOfDays = end.diff(start, "days").days;
    const daysArray = [];

    for (let i = 0; i <= numberOfDays; i++) {
      daysArray.push(start.plus({ days: i }).toJSDate());
    }

    return daysArray;
  }, [startBlock, endBlock]);

  const tripItems = useAllTripItineraryItems(selectedTrip, {
    includeLodging: true,
    includeFlights: true,
  });

  // Map calendar items to the corresponding days
  const calendarItems = useMemo(() => {
    return days.map((day) => {
      // Format date consistently with useAllTripItineraryItems
      const formattedDate = DateTime.fromJSDate(day).toFormat("yyyy-MM-dd");
      const dayItems = tripItems.find((item) => item.date === formattedDate);

      return {
        date: formattedDate,
        items: dayItems?.items || [],
      };
    });
  }, [days, tripItems]);

  return {
    days,
    calendarItems,
  };
};
